import ReactGA from "react-ga4";

export const COOKIE_CONSENT_KEY = "cookieConsent";
export const COOKIE_CONSENT_ACCEPTED = "accepted";
export const COOKIE_CONSENT_REJECTED = "rejected";

let analyticsInitialized = false;

const getPagePath = () => {
  if (typeof window === "undefined") {
    return "";
  }

  return window.location.pathname;
};

export const getCookieConsent = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.localStorage.getItem(COOKIE_CONSENT_KEY);
};

export const hasAnalyticsConsent = () => {
  return getCookieConsent() === COOKIE_CONSENT_ACCEPTED;
};

export const initializeAnalytics = () => {
  if (!hasAnalyticsConsent() || analyticsInitialized) {
    return false;
  }

  ReactGA.initialize("G-L1DM2PQPZY");
  analyticsInitialized = true;

  return true;
};

export const trackPageView = (path = getPagePath()) => {
  if (!hasAnalyticsConsent()) {
    return;
  }

  try {
    initializeAnalytics();
    ReactGA.send({ hitType: "pageview", page: path });
  } catch (error) {
    console.error("Analytics page view failed:", error);
  }
};

const trackEvent = (eventName, location) => {
  if (!hasAnalyticsConsent()) {
    return;
  }

  try {
    initializeAnalytics();
    ReactGA.event(eventName, {
      location,
      page_path: getPagePath(),
    });
  } catch (error) {
    console.error("Analytics event failed:", error);
  }
};

export const trackWhatsAppClick = (location) => {
  trackEvent("whatsapp_click", location);
};

export const trackPhoneClick = (location) => {
  trackEvent("phone_click", location);
};

export const trackBookingClick = (location) => {
  trackEvent("booking_click", location);
};

export const trackBookingSubmit = (location) => {
  trackEvent("booking_submit", location);
};
